import React, { useState } from 'react'
import { Button } from 'Components/common/bulma'
import { ModalRemove, InformationModal } from 'Components/common'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { createCreditNoteTotalAmountAction } from 'Modules/incomeOrders/creditNote'
import { addNotification as addNotificationAction } from 'Modules/principal';

function CancelOrder({
  createCreditNoteTotalAmount,
  order,
  addNotification,
  onClose,
}) {
  const [isConfirming, setIsConfirming] = useState(false)
  const [isCanceled, setIsCanceled] = useState(false)
  const confirmCancel = () => {
    setIsConfirming(true)
  }

  const closeConfirm = () => {
    setIsConfirming(false)
  }

  const handleOnCancel = () => {
    setIsConfirming(false)
    createCreditNoteTotalAmount().then(() => {
      setIsCanceled(true)
    }).catch(({ response: { data } }) => {
      addNotification({
        type: 'danger',
        message: data.message,
      })
    })
  }

  const closeCanceledModal = () => {
    setIsCanceled(false)
    onClose(true)
  }

  return (
    <>
      <InformationModal
        isOpen={isCanceled}
        closeModal={closeCanceledModal}
        title="Orden cancelada"
        content="Petición recibida, en las próximas horas se emitirá la nota de crédito."
      />
      <ModalRemove
        isDeleting={isConfirming}
        title="Generar Nota de Crédito"
        toggleModal={closeConfirm}
        confirmText="Se procederá a crear la nota de crédito"
        resource={order.id}
        deleteResource={handleOnCancel}
        actionButtonLabel="Emitir"
        cancelButtonLabel="Regresar"
      />
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        Se Emitirá la nota de crédito por el monto total de la factura
        <Button onClick={confirmCancel}>
          Generar nota de crédito
        </Button>
      </div>
    </>
  )
}

const mapStateToProps = ({ incomeOrders: { invoice } }) => ({
  order: invoice.order,
})

const mapDispatchToProps = dispatch => bindActionCreators({
  createCreditNoteTotalAmount: createCreditNoteTotalAmountAction,
  addNotification: addNotificationAction,
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(CancelOrder)
